import { ChartConfig, ChartName, SubMenuOption } from "./analyticsTypes";
import { startCase } from "lodash";
import { CompactMenu, CompactMenuItem, RemoveOption, StyledHr } from "./styles/filter.styles";

// Default options for component
const defaultOptions: SubMenuOption[] = [
  {
    label: "week",
    value: "1W",
  },
  {
    label: "month",
    value: "1M",
  },
  {
    label: "1 year",
    value: "1Y",
  },
  {
    label: "all time",
    value: "ALL",
  },
];

interface DropdownSubmenuProps {
  id: ChartName | string;
  anchorEl: HTMLElement | null;
  open: boolean;
  options?: SubMenuOption[];
  selected?: string;
  chart?: ChartConfig<any>;
  onClose: () => void;
  onSelection: (selection: SubMenuOption) => void;
  onRemove?: () => void;
}

const DropdownSubmenu = (props: DropdownSubmenuProps) => {
  const {
    id,
    anchorEl,
    open,
    options = defaultOptions,
    selected,
    chart,
    onClose,
    onSelection,
    onRemove,
  } = props;

  /**
   * Downloads chart data as a CSV file.
   *
   * This function takes the current chart data and converts it into a CSV format, then
   * triggers a browser download. The CSV file will be named using the chart's title.
   */
  const downloadAsCSV = () => {
    if (!chart) return;
    const { title, data } = chart;
    // Extract column headers from the first data row
    const headers = Object.keys(data[0]).join(",");
    // Convert each data row into CSV format
    const rows = data.map((row) => Object.values(row).join(","));
    // Combine headers and rows into complete CSV content
    const csvContent = `${headers}\n${rows.join("\n")}`;
    // Create a Blob containing the CSV data
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    // Create and trigger a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `${title}.csv`;
    downloadLink.click();
  };

  return (
    <CompactMenu
      elevation={0}
      id={id}
      anchorEl={anchorEl}
      keepMounted
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={onClose}>
      {options.map((option) => (
        <CompactMenuItem
          key={option.label}
          onClick={() => onSelection(option)}
          selected={selected === option.label}>
          {startCase(option.label)}
        </CompactMenuItem>
      ))}
      {chart && (
        <div>
          <StyledHr />

          <CompactMenuItem onClick={downloadAsCSV}>Download</CompactMenuItem>
          <CompactMenuItem onClick={onRemove}>
            <RemoveOption id="remove-button">Remove</RemoveOption>
          </CompactMenuItem>
        </div>
      )}
    </CompactMenu>
  );
};

export default DropdownSubmenu;
